import React from 'react';
import VideoUploaderForStyleSettings from 'components/VideoUploader/VideoUploaderForStyleSettings';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './ThumbItem.module.scss';

interface IThumbVideoItem {
	onClick: () => void;
	selected: boolean;
	isMakeRequest: boolean;
	filePath: Nullable<string>;
	translationId: string;
	sourceUrl: string;
}

const ThumbVideoItem: React.FC<IThumbVideoItem> = ({
	onClick,
	selected,
	isMakeRequest,
	filePath,
	translationId,
	sourceUrl,
}) => {
	return (
		<div className={`${style.emblaSlide} ${style.emblaSlideThumb} ${selected ? style.isSelected : ''}`}>
			<button
				onClick={onClick}
				className={`${style.emblaSlideInner} ${style.emblaSlideInnerThumb}`}
				type="button">
				{filePath ? (
					<span className={style.emblaSlideThumbnailDiv}>
						<VideoUploaderForStyleSettings
							translationID={translationId}
							isMakeImageRequest={isMakeRequest}
							loaderSize="big"
							isShowControls={false}
							filePath={selected ? filePath : null}
						/>
					</span>
				) : (
					<video className={style.emblaSlideThumbnailImg} controls={false} src={sourceUrl} />
				)}
				<div className={style.overlayForThumb}>
					<svg>
						<use xlinkHref={`${breadcrumbs}#playBtn`} />
					</svg>
				</div>
			</button>
		</div>
	);
};

export default React.memo(ThumbVideoItem);
